import { useState, useRef } from 'react';
import React, { useEffect, Fragment } from 'react';
import { ArrowLeft, Save, X, Plus, Trash, Trash2, Upload, Image, Film, } from 'lucide-react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getProductPackage, createProductPackage, updateProductPackage, uploadPackageAsset } from '../../actions/productPackage';
import { connect } from 'react-redux';
import { getProducts } from '../../actions/product';
import { getAccessories } from '../../actions/accessory';
import { setAlert } from '../../actions/alert';

// export default function FormPage() {
const Package = ({getProductPackage, createProductPackage, updateProductPackage, getAccessories,
  uploadPackageAsset, setAlert, productPackage, loading, products, getProducts, assetPath, accessories}) => {

    const [productData, setProductData] = useState({})
    const [productType, setProductType] = useState({ 'water': "Water",'membership': "Membership", 'accessory': "Accessory",
        'refundableDeposit': "Refundable Deposit" });
    const [onModel, setOnModel] = useState({"Accessory":"Accessory", "Product": "Product"});
    

      const [selectedFile, setSelectedFile] = useState(null);
      const [previewUrl, setPreviewUrl] = useState('');
    const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    tagline: '',
    packageContent: [''],
    productInfo: [{title:"", description:""}],
    validity: {
      days: '',
      info: '',
      unlimited: false
    },
    expired: false,
    allowCombo: false,
    oneTimePurchase: false,
    minQuantity: '',
    maxQuantity: '',
    totalPriceInfo: {
      standard: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      },
      discount: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      },
      membership: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      }
    },
    assets: [],
    bundle:[
        {
            product:"",
            onModel:"",
            productType:"",
            quantity:"",
            gst:"",
            priceInfo:{
                standard:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                discount:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                membership:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                }
            }
        }
    ]
  });
  
  const [errors, setErrors] = useState({
    name: '',
    tagline: '',
    packageContent: [],
    productInfo:[],
    validity: {
      days: '',
      info: ''
    },
    minQuantity: '',
    maxQuantity: '',
    totalPriceInfo: {
      standard: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      },
      discount: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      },
      membership: {
        basePrice: '',
        price: '',
        percentage: '',
        gstAmount: ''
      }
    },
    bundle:[],
    assets: []
  });

  const { id } = useParams();
  const navigate = useNavigate();

    useEffect(() => {
        document.title = id === 'new' ? 'Create Package' : 'Edit Package';
        // Always fetch products regardless of whether it's new or existing package
        if(!products || products.length === 0){
            getProducts();
        }

        if(!accessories || accessories.length === 0){
            getAccessories();
        }
        
        if(id !== 'new'){
            if(!productPackage || (productPackage._id !== id) || loading){
                getProductPackage(id)
            }
            if(productPackage){
                setFormData({
                    ...formData,
                    ...productPackage
                  });
            }
        }
        
        // Process products and accessories data for both new and existing packages
        if(products || accessories){
            let tempProduct = {}
            
            // Add products to the dropdown
            if(products){
                products.forEach((product, index) => {
                    tempProduct[product._id] = {
                        brand: product.brand,
                        type: 'Product',
                        name: product.brand
                    }
                })
            }
            
            // Add accessories to the dropdown
            if(accessories){
                accessories.forEach((accessory, index) => {
                    tempProduct[accessory._id] = {
                        brand: accessory.name,
                        type: 'Accessory',
                        name: accessory.name
                    }
                })
            }
            
            setProductData(tempProduct)
        }
    }, [productPackage, loading, products, accessories]);
  
  
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    
    setFormData({
      ...formData,
      [name]: newValue
    });
    
    // Clear error when typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleAddProductChange = (index, e, priceInfo=false, priceType) =>{    
    const { name, value } = e.target;
    const updatedContent = [...formData.bundle];
    if(priceInfo){
        updatedContent[index].priceInfo[priceType][name] = value;
    }else{
        updatedContent[index][name] = value;
        
        // If product is being changed, set the name from productData
        if(name === 'product' && value && productData[value]){
            updatedContent[index].name = productData[value].brand;
        }
    }    
    
    setFormData({
      ...formData,
      bundle: updatedContent
    });

  }
  
  const handleValidityChange = (field, value) => {
    setFormData({
      ...formData,
      validity: {
        ...formData.validity,
        [field]: value
      }
    });
    
    // Clear error when typing
    if (errors.validity && errors.validity[field]) {
      setErrors({
        ...errors,
        validity: {
          ...errors.validity,
          [field]: ''
        }
      });
    }
  };
  
  const handlePriceInfoChange = (category, field, value) => {
    setFormData({
      ...formData,
      totalPriceInfo: {
        ...formData.totalPriceInfo,
        [category]: {
          ...formData.totalPriceInfo[category],
          [field]: value
        }
      }
    });
    
    // Clear error when typing
    if (errors.totalPriceInfo && errors.totalPriceInfo[category] && errors.totalPriceInfo[category][field]) {
      setErrors({
        ...errors,
        totalPriceInfo: {
          ...errors.totalPriceInfo,
          [category]: {
            ...errors.totalPriceInfo[category],
            [field]: ''
          }
        }
      });
    }
  };
  
  const handlePackageContentChange = (index, value) => {
    const updatedContent = [...formData.packageContent];
    updatedContent[index] = value;
    
    setFormData({
      ...formData,
      packageContent: updatedContent
    });
    
    // Clear error for this index when typing
    if (errors.packageContent && errors.packageContent[index]) {
      const updatedErrors = [...errors.packageContent];
      updatedErrors[index] = '';
      setErrors({
        ...errors,
        packageContent: updatedErrors
      });
    }
  };

  const handleProductInfoContentChange = (index, value, type) => {
    const updatedContent = [...formData.productInfo];
    updatedContent[index][type] = value;
    
    setFormData({
      ...formData,
      productInfo: updatedContent
    });
    
    // Clear error for this index when typing
    if (errors.productInfo && errors.productInfo[index]) {
      const updatedErrors = [...errors.productInfo];
      updatedErrors[index] = '';
      setErrors({
        ...errors,
        productInfo: updatedErrors
      });
    }
  };
  
  const addPackageContentField = () => {
    setFormData({
      ...formData,
      packageContent: [...formData.packageContent, '']
    });
  };

  const addProductInfoContentField = () => {
    setFormData({
      ...formData,
      productInfo: [...formData.productInfo, {"title":"", "description":""}]
    });
  };

  const addProduct = () => {
   let bundle =
        {
            product:"",
            onModel:"",
            productType:"",
            quantity:"",
            gst:"",
            priceInfo:{
                standard:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                discount:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                membership:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                }
            }
        }
    setFormData({
        ...formData,
        bundle: [...formData.bundle, bundle]
      });
  }
  
  const removePackageContentField = (index) => {
    const updatedContent = formData.packageContent.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      packageContent: updatedContent
    });
    
    // Also remove any errors for this index
    if (errors.packageContent && errors.packageContent.length > 0) {
      const updatedErrors = errors.packageContent.filter((_, i) => i !== index);
      setErrors({
        ...errors,
        packageContent: updatedErrors
      });
    }
  };

  const removeProductInfoContentField = (index) => {
    const updatedContent = formData.productInfo.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      productInfo: updatedContent
    });
    
    // Also remove any errors for this index
    if (errors.productInfo && errors.productInfo.length > 0) {
      const updatedErrors = errors.productInfo.filter((_, i) => i !== index);
      setErrors({
        ...errors,
        productInfo: updatedErrors
      });
    }
  };

  const removeProduct = (index) => {
    const updatedContent = formData.bundle.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      bundle: updatedContent
    });
    
    // Also remove any errors for this index
    if (errors.bundle && errors.bundle.length > 0) {
      const updatedErrors = errors.bundle.filter((_, i) => i !== index);
      setErrors({
        ...errors,
        bundle: updatedErrors
      });
    }
  }
  


  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Ensure all bundle items have names set
    const updatedFormData = {
      ...formData,
      bundle: formData.bundle.map(bundleItem => ({
        ...bundleItem,
        name: bundleItem.name || (bundleItem.product && productData[bundleItem.product] ? productData[bundleItem.product].brand : '')
      }))
    };
    
    if (id === 'new') {
      // Create new package
      const result = await createProductPackage(updatedFormData);
      if (result) {
        // Navigate to the created package page
        navigate(`/inventory/v1.2/product-package/${result._id}`);
      }
    } else {
      // Update existing package
      const result = await updateProductPackage(updatedFormData);
      if (result) {
        // Package updated successfully
        console.log('Package updated successfully');
      }
    }
  };
  
  const handleReset = () => {
    setFormData({
      name: '',
      tagline: '',
      packageContent: [''],
      productInfo: [{"title":"", "description":""}],
      validity: {
        days: '',
        info: '',
        unlimited: false
      },
      expired: false,
      allowCombo: false,
      oneTimePurchase: false,
      minQuantity: '',
      maxQuantity: '',
      totalPriceInfo: {
        standard: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        },
        discount: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        },
        membership: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        }
      },
      assets: [],
      bundle:[
        {
            product:"",
            onModel:"",
            productType:"",
            quantity:"",
            gst:"",
            priceInfo:{
                standard:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                discount:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                },
                membership:{
                    unitPrice:"",
                    baseUnitPrice:"",
                    gstForUnit:"",
                    basePrice:"",
                    price:"",
                    gstAmount:""
                }
            }
        }
    ]
    });
    
    setErrors({
      name: '',
      tagline: '',
      packageContent: [],
      validity: {
        days: '',
        info: ''
      },
      minQuantity: '',
      maxQuantity: '',
      totalPriceInfo: {
        standard: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        },
        discount: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        },
        membership: {
          basePrice: '',
          price: '',
          percentage: '',
          gstAmount: ''
        }
      }
    });
  };

  // Price category titles for display
  const priceCategoryTitles = {
    standard: 'Standard Price',
    discount: 'Discount Price',
    membership: 'Membership Price'
  };

// Upload Assets

const handleDelete = (id) => {
    //setMediaItems(mediaItems.filter(item => item.id !== id));
    setFormData({
        ...formData,
        assets: formData.assets.filter(item => item._id !== id)
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    
    // Determine if it's an image or video
    const fileType = file.type.startsWith('image/') ? 'image' : 
                    file.type.startsWith('video/') ? 'video' : null;
    
    if (fileType) {
      // Create a preview URL
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
      
      // Auto-fill title with filename (without extension)
      const fileName = file.name.split('.').slice(0, -1).join('.');
    } else {
      alert('Please select an image or video file.');
      setSelectedFile(null);
      setPreviewUrl('');
    }
  };

  const uploadPackageImage = async (e) => {
    e.preventDefault();
    
    if (!selectedFile) {
      setAlert('Please select a file first', 'danger');
      return;
    }
    
    if (!productPackage || !productPackage._id) {
      setAlert('Package must be saved before uploading assets', 'danger');
      return;
    }
    
    const formData = new FormData();
    formData.append('file', selectedFile);    
    try {
      const result = await uploadPackageAsset(productPackage._id, formData);
      if (result) {
        // Clear the form after successful upload
        clearFileSelection();
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  }



  const clearFileSelection = () => {
    setSelectedFile(null);
    setPreviewUrl('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };


  return (
    <Fragment>
        <div className='container-fluid py-4'>
            {/* Header */}
            <div className='row mb-4'>
                <div className='col-12'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Link className='btn btn-outline-primary' to='/inventory/v1.2/product-package'>
                            <ArrowLeft size={16} className="me-2" />
                            Back to Packages
                </Link>
                        <h2 className='text-primary mb-0'>
                            {id === 'new' ? 'Create New Package' : 'Edit Package'}
                        </h2>
                        <div></div>
            </div>
                </div>
            </div>

            <form onSubmit={onSubmit}>
                <div className='row'>
                    {/* Main Form Content */}
                    <div className='col-lg-8'>
                        {/* Basic Information Card */}
                        <div className='card shadow-sm mb-4'>
                            <div className='card-header bg-primary text-white'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-info-circle me-2'></i>
                                    Basic Information
                                </h5>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-md-6 mb-3'>
                                        <label className='form-label fw-bold'>
                                            Package Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                                            className="form-control form-control-lg"
                                            placeholder="Enter package name"
                                            required
                    />
                </div>
                                    <div className='col-md-6 mb-3'>
                                        <label className='form-label fw-bold'>
                                            Tagline <span className="text-danger">*</span>
                        </label>
                        <input
                        type="text"
                        name="tagline"
                        value={formData.tagline}
                        onChange={handleChange}
                                            className="form-control form-control-lg"
                                            placeholder="Enter catchy tagline"
                                            required
                        />                    
                </div>
                                    <div className='col-md-6 mb-3'>
                                        <label className='form-label fw-bold'>
                                            Package Type {id === 'new' && <span className="text-danger">*</span>}
                                        </label>
                                        <select
                                            name="packageType"
                                            value={formData.packageType || ''}
                                            onChange={handleChange}
                                            className="form-select form-select-lg"
                                            required={id === 'new'}
                                        >
                                            {id === 'new' && <option value="">Select Package Type</option>}
                                            <option value="product">Product</option>
                                            <option value="membership">Membership</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Options Row */}
                                <div className='row'>
                                    <div className='col-12'>
                                        <label className='form-label fw-bold mb-3'>Package Options</label>
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className="form-check form-switch">
                      <input
                                                        className="form-check-input"
                        type="checkbox"
                        id="expired"
                        name="expired"
                        checked={formData.expired}
                        onChange={handleChange}
                      />
                                                    <label className="form-check-label" htmlFor="expired">
                        Expired
                      </label>
                    </div>
                </div>
                                            <div className='col-md-4'>
                                                <div className="form-check form-switch">
                      <input
                                                        className="form-check-input"
                        type="checkbox"
                        id="allowCombo"
                        name="allowCombo"
                        checked={formData.allowCombo}
                        onChange={handleChange}
                      />
                                                    <label className="form-check-label" htmlFor="allowCombo">
                        Allow Combo
                      </label>
                    </div>
                  </div>
                                            <div className='col-md-4'>
                                                <div className="form-check form-switch">
                      <input
                                                        className="form-check-input"
                        type="checkbox"
                        id="oneTimePurchase"
                        name="oneTimePurchase"
                        checked={formData.oneTimePurchase}
                        onChange={handleChange}
                      />
                                                    <label className="form-check-label" htmlFor="oneTimePurchase">
                      One Time Purchase
                      </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                  </div>
              
                        {/* Quantity & Validity Card */}
                        <div className='card shadow-sm mb-4'>
                            <div className='card-header bg-info text-white'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-chart-line me-2'></i>
                                    Quantity & Validity
                                </h5>
            </div>  
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-md-3 mb-3'>
                                        <label className='form-label fw-bold'>Min Quantity</label>
                    <input
                      type="number"
                      name="minQuantity"
                      value={formData.minQuantity}
                      onChange={handleChange}
                      min="0"
                                            className="form-control"
                                            placeholder="0"
                    />                    
                  </div>
                                    <div className='col-md-3 mb-3'>
                                        <label className='form-label fw-bold'>Max Quantity</label>
                    <input
                      type="number"
                      name="maxQuantity"
                      value={formData.maxQuantity}
                      onChange={handleChange}
                      min="1"
                                            className="form-control"
                                            placeholder="10"
                    />                    
                  </div>
                                    <div className='col-md-3 mb-3'>
                                        <label className='form-label fw-bold mb-3'>Validity Options</label>
                                        <div className="form-check form-switch mb-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="unlimited"
                                                checked={formData.validity.unlimited}
                                                onChange={(e) => handleValidityChange('unlimited', e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="unlimited">
                                                Unlimited Validity
                                            </label>
                                        </div>
                                        {!formData.validity.unlimited && (
                                            <>
                                                <label className='form-label fw-bold'>
                                                    Validity Days <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    value={formData.validity.days}
                                                    onChange={(e) => handleValidityChange('days', e.target.value)}
                                                    min="1"
                                                    className="form-control"
                                                    placeholder="30"
                                                    required={!formData.validity.unlimited}
                                                />
                                            </>
                                        )}
                  </div>
                                    <div className='col-md-3 mb-3'>
                                        <label className='form-label fw-bold'>
                                            Validity Info <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.validity.info}
                      onChange={(e) => handleValidityChange('info', e.target.value)}
                                            className="form-control"
                                            placeholder="Valid for 30 days"
                                            required
                    />                
                                    </div>
                                </div>
                            </div>
                  </div>
              
                        {/* Package Content Card */}
                        <div className='card shadow-sm mb-4'>
                            <div className='card-header bg-success text-white d-flex justify-content-between align-items-center'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-list me-2'></i>
                                    Package Content
                                </h5>
                                <button
                                    type="button"
                                    onClick={addPackageContentField}
                                    className="btn btn-light btn-sm"
                                >
                                    <Plus size={16} className="me-1" />
                                    Add Item
                                </button>
                            </div>
                            <div className='card-body'>
                                {formData.packageContent.map((content, index) => (
                                    <div key={index} className="input-group mb-3">
                                        <span className="input-group-text">#{index + 1}</span>
                                        <input
                                            type="text"
                                            value={content}
                                            onChange={(e) => handlePackageContentChange(index, e.target.value)}
                                            className="form-control"
                                            placeholder={`Package item ${index + 1}`}
                                            required
                                        />
                                        {formData.packageContent.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removePackageContentField(index)}
                                                className="btn btn-outline-danger"
                                            >
                                                <Trash size={16} />
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Product Info Card */}
                        <div className='card shadow-sm mb-4'>
                            <div className='card-header bg-warning text-dark d-flex justify-content-between align-items-center'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-info me-2'></i>
                                    Product Information
                                </h5>
                                <button
                                    type="button"
                                    onClick={addProductInfoContentField}
                                    className="btn btn-dark btn-sm"
                                >
                                    <Plus size={16} className="me-1" />
                                    Add Info
                                </button>
                </div>
                            <div className='card-body'>
                                {formData.productInfo.map((content, index) => (
                                    <div key={index} className="row mb-3">
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                value={content.title}
                                                onChange={(e) => handleProductInfoContentChange(index, e.target.value, "title")}
                                                className="form-control"
                                                placeholder="Title"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-7">
                                            <textarea
                                                rows="2"
                                                value={content.description}
                                                onChange={(e) => handleProductInfoContentChange(index, e.target.value, "description")}
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-1">
                                            {formData.productInfo.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeProductInfoContentField(index)}
                                                    className="btn btn-outline-danger"
                                                >
                                                    <Trash size={16} />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Sidebar */}
                    <div className='col-lg-4'>
                        {/* Price Information Card */}
                        <div className='card shadow-sm mb-4'>
                            <div className='card-header bg-secondary text-white'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-dollar-sign me-2'></i>
                                    Price Information
                                </h5>
                            </div>
                            <div className='card-body'>
                {Object.keys(formData.totalPriceInfo).map((category) => (
                                    <div key={category} className="mb-4">
                                        <h6 className="text-capitalize fw-bold border-bottom pb-2 mb-3">
                                            {priceCategoryTitles[category]}
                                        </h6>
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <label className="form-label small">
                                                    Price {category === 'standard' && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          value={formData.totalPriceInfo[category].price}
                          onChange={(e) => handlePriceInfoChange(category, 'price', e.target.value)}
                          step="0.01"
                          min="0"
                                                    className="form-control form-control-sm"
                                                    placeholder="0.00"
                                                    required
                        />        
                      </div>
                                            <div className="col-6">
                                                <label className="form-label small">
                                                    Base Price {category === 'standard' && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          value={formData.totalPriceInfo[category].basePrice}
                          onChange={(e) => handlePriceInfoChange(category, 'basePrice', e.target.value)}
                          step="0.01"
                          min="0"
                                                    className="form-control form-control-sm"
                                                    placeholder="0.00"
                                                    required
                        />                        
                      </div>
                                            <div className="col-6">
                                                <label className="form-label small">
                                                    Percentage (Discount) {category === 'standard' && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="string"
                          value={formData.totalPriceInfo[category].percentage}
                          onChange={(e) => handlePriceInfoChange(category, 'percentage', e.target.value)}
                          step="0.01"
                          min="0"
                          max="100"
                                                    className="form-control form-control-sm"
                                                    placeholder="0.00"
                                                    required
                        />                        
                      </div>
                                            <div className="col-6">
                                                <label className="form-label small">
                                                    GST Amount {category === 'standard' && <span className="text-danger">*</span>}
                        </label>
                        <input
                          type="number"
                          value={formData.totalPriceInfo[category].gstAmount}
                          onChange={(e) => handlePriceInfoChange(category, 'gstAmount', e.target.value)}
                          step="0.01"
                          min="0"
                                                    className="form-control form-control-sm"
                                                    placeholder="0.00"
                                                    required
                        />                        
                      </div>
                    </div>
                  </div>
                ))}
                            </div>
                </div>
                
                        {/* Actions Card */}
                        <div className='card shadow-sm'>
                            <div className='card-body text-center'>
                                {id === 'new' && (
                        <button
                          type="button"
                                        onClick={handleReset}
                                        className="btn btn-outline-secondary me-2"
                        >
                                        <X size={16} className="me-1" />
                                        Reset
                        </button>
                      )}
                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    <Save size={16} className="me-1" />
                                    {id === 'new' ? 'Create Package' : 'Update Package'}
                  </button>
              </div>
                        </div>
                    </div>
                </div>
                
                {/* Products in Package Section */}
                <div className='row mt-4'>
                    <div className='col-12'>
                        <div className='card shadow-sm'>
                            <div className='card-header bg-dark text-white d-flex justify-content-between align-items-center'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-box me-2'></i>
                                    Products in Package
                                </h5>
                        <button
                          type="button"
                                    onClick={addProduct}
                                    className="btn btn-light btn-sm"
                        >
                                    <Plus size={16} className="me-1" />
                                    Add Product
                        </button>
                    </div>
                            <div className='card-body'>
                                {formData.bundle.map((content, index) => (
                                    <div key={index} className="border rounded p-3 mb-3 bg-light">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="mb-0 text-primary">Product #{index + 1}</h6>
                                            {formData.bundle.length > 1 && (
                <button
                    type="button"
                                                    onClick={() => removeProduct(index)}
                                                    className="btn btn-sm btn-outline-danger"
                                                >
                                                    <Trash size={16} />
                  </button>
                                            )}
              </div>

                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label fw-bold">Product/Accessory</label>
                            <select 
                            name="product"
                            value={content.product} 
                            onChange={(e) => handleAddProductChange(index, e)} 
                                                    className="form-select"
                                                    required
                                                >
                                                    <option value="">Select Product or Accessory</option>
                                                    {productData && Object.keys(productData).map((key, idx) => (
                                                        <option key={idx} value={key}>
                                                            {productData[key].brand} ({productData[key].type})
                                                        </option>
                                                    ))}
                            </select>
                        </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-bold">Product Type</label>
                                                <select
                                                    name="productType"
                                                    value={content.productType}
                            onChange={(e) => handleAddProductChange(index, e)}
                                                    className="form-select"
                                                    required
                                                >
                                                    <option value="">Select Type</option>
                                                    {Object.keys(productType).map((key, idx) => (
                                                        <option key={idx} value={key}>
                                                            {productType[key]}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-bold">On Model</label>
                            <select 
                            name="onModel"
                            value={content.onModel} 
                            onChange={(e) => handleAddProductChange(index, e)} 
                                                    className="form-select"
                                                    required
                                                >
                                                    <option value="">Select Model</option>
                                                    {Object.keys(onModel).map((key, idx) => (
                                                        <option key={idx} value={key}>
                                                            {onModel[key]}
                                                        </option>
                                                    ))}
                            </select>
                        </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Quantity</label>
                            <input
                                                    type="number"
                                                    name="quantity"
                                                    value={content.quantity}
                            onChange={(e) => handleAddProductChange(index, e)}
                                                    className="form-control"
                                                    placeholder="1"
                                                    min="1"
                                                    required
                                                />
                        </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">GST %</label>
                            <input
                                                    type="number"
                            name="gst"
                            value={content.gst}
                            onChange={(e) => handleAddProductChange(index, e)}
                                                    className="form-control"
                                                    placeholder="18"
                                                    step="0.01"
                                                    required
                            />
                        </div>
                        </div>

                                        {/* Price Info for this product */}
                                        <div className="mt-4">
                                            <h6 className="text-secondary mb-3">Price Information</h6>
                        {Object.keys(content.priceInfo).map((category) => (
                                                <div key={category} className="mb-3">
                                                    <div className="bg-white p-3 rounded border">
                                                        <h6 className="text-capitalize text-primary mb-2">
                                                            {priceCategoryTitles[category]}
                                                        </h6>
                                                        <div className="row g-2">
                                                            {['unitPrice', 'baseUnitPrice','gstForUnit', 'price', 'basePrice', 'gstAmount'].filter(field => 
                                                                content.priceInfo[category].hasOwnProperty(field)
                                                            ).map((field) => (
                                                                <div key={field} className="col-md-2">
                                                                    <label className="form-label small text-muted">
                                                                        {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                </label>
                                <input
                                                                        type="number"
                                                                        name={field}
                                                                        value={content.priceInfo[category][field]}
                                onChange={(e) => handleAddProductChange(index, e, true, category)}
                                required
                                                                        className="form-control form-control-sm"
                                                                        placeholder="0.00"
                                                                        step="0.01"
                                />
                            </div>
                                                            ))}
                            </div>
                            </div>
                            </div>
                                            ))}
                            </div>
                    </div>
                ))}
                </div>
                </div>
                </div>
            </div>
          </form>

            {/* Assets Section - Only for editing existing packages */}
            {id !== 'new' && (
                <div className='row mt-4'>
                    <div className='col-12'>
                        <div className='card shadow-sm'>
                            <div className='card-header bg-info text-white'>
                                <h5 className='mb-0'>
                                    <i className='fas fa-images me-2'></i>
                                    Package Assets
                                </h5>
                </div>
                            <div className='card-body'>
                                {/* File Upload Section */}
                                <div className="row mb-4">
                                    <div className="col-md-9">
                                        <label className="form-label fw-bold">Upload Media</label>
                    <input
                        type="file"
                        ref={fileInputRef}
                        accept="image/*,video/*"
                                            className="form-control"
                        onChange={handleFileChange}
                    />
                    {selectedFile && (
                                            <div className="mt-2">
                        <button 
                        type="button" 
                        onClick={clearFileSelection}
                                                    className="btn btn-sm btn-outline-secondary"
                        >
                                                    <X size={16} className="me-1" />
                                                    Clear Selection
                        </button>
                                            </div>
                    )}
                    </div>
                                    <div className="col-md-3 d-flex align-items-end">
                                        <button
                                            disabled={!selectedFile}
                                            onClick={uploadPackageImage}
                                            type="button"
                                            className="btn btn-primary w-100"
                                        >
                                            <Upload size={16} className="me-1" />
                                            Upload
                                        </button>
                                    </div>
                </div>
          
                {/* Preview */}
                {previewUrl && (
                                    <div className="mb-4">
                                        <label className="form-label fw-bold">Preview</label>
                                        <div className="border rounded p-3 bg-light">
                        {selectedFile && selectedFile.type.startsWith('image/') ? (
                        <img 
                            src={previewUrl} 
                            alt="Preview" 
                                                    className="img-fluid rounded"
                                                    style={{maxHeight: '200px'}}
                        />
                        ) : selectedFile && selectedFile.type.startsWith('video/') ? (
                        <video
                            src={previewUrl} 
                                                    className="img-fluid rounded"
                            controls
                                                    style={{maxHeight: '200px'}}
                        />
                        ) : null}
                    </div>
                    </div>
                )}
          
                                {/* Assets Gallery */}
                                <div className="row">
                {formData.assets.map((item, index) => (
                                        <div key={index} className="col-md-3 mb-3">
                                            <div className="card h-100">
                                                <div className="position-relative">
                                    {item.assetType === 'image' ? ( 
                                        <img 
                                        src={assetPath + item.asset} 
                                                            className="card-img-top"
                                                            style={{height: '200px', objectFit: 'cover'}}
                                                            alt="Package asset"
                                        />
                                    ) : (
                                        <video 
                                        src={assetPath + item.asset} 
                                                            className="card-img-top"
                                                            style={{height: '200px', objectFit: 'cover'}}
                                                            controls
                                        />
                                    )}
                                                    <div className="position-absolute top-0 end-0 m-2">
                                                        <span className="badge bg-dark">
                                    {item.assetType === 'video' ? (
                                                                <Film size={16} />
                                    ) : (
                                                                <Image size={16} />
                                    )}
                                                        </span>
                                </div>
                                </div>                        
                                                <div className="card-body text-center">
                            <button
                                                        onClick={() => handleDelete(item._id)}
                                                        className="btn btn-outline-danger btn-sm"
                                                        type="button"
                                                    >
                                                        <Trash2 size={16} className="me-1" />
                                                        Delete
                            </button>
                        </div>
                        </div>
                    </div>
                    ))}
                                </div>
      
                {formData.assets.length === 0 && (
                                    <div className="text-center py-5 text-muted">
                                        <i className="fas fa-images fa-3x mb-3"></i>
                                        <p>No media assets uploaded yet. Upload images or videos for this package.</p>
                    </div>
                )}
        </div> 
          </div>
          </div>
                </div>
            )}
    </div>
    </Fragment>
  );
}

Package.propTypes = {
    getProductPackage: PropTypes.func.isRequired,
    createProductPackage: PropTypes.func.isRequired,
    updateProductPackage: PropTypes.func.isRequired,
    uploadPackageAsset: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    productPackage: PropTypes.object,
    getProducts : PropTypes.func.isRequired,
    getAccessories: PropTypes.func.isRequired,
    accessories: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    loading: state.productPackage.loading,
    productPackage: state.productPackage.package,
    assetPath: state.productPackage.assetPath,
    products: state.product.products,
    accessories: state.accessory.accessories
});

export default connect( mapStateToProps, { getProductPackage, createProductPackage, updateProductPackage,
  uploadPackageAsset, setAlert, getProducts, getAccessories } )(Package);